<script>
import { layoutMethods, erpFixMessages, coreEloadDropdownMethods, coreEloadDropdownComputed, coreEloadSKUMasterMethods, coreEloadSKUMasterComputed } from '@/state/helpers';
import Swal from 'sweetalert2';
import { getModuleAccess } from '@/router/helper.js';

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load SKU Master",
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "skuId",
      sortDesc: true,
      searchListPromo: [
        { text: "Search All", value: null },
        { text: "Network", value: 'service' },
        { text: "Promo Name", value: 'sku_name' },
        { text: "Validity", value: 'validity' }
      ],
      fields: [
        {
          key: "skuId",
          label: "Promo ID",
          sortable: true,
        },
        {
          key: "skuName",
          label: "Promo Name",
          sortable: true,
        },
        {
          key: "skuCode",
          label: "Promo Code",
          sortable: true,
        },
        {
          key: "skuStatus",
          label: "Status",
          sortable: true,
        },
        {
          key: "providerName",
          label: "Provider",
          sortable: true,
        },
        {
          key: "skuCategory",
          label: "Category",
          sortable: true,
        },
        {
          key: "skuServiceGroup",
          label: "Network",
          sortable: true,
        },
        {
          key: "skuService",
          label: "Service",
          sortable: true,
        },
        {
          key: "skuDescription",
          label: "Description",
          sortable: false,
        },
        {
          key: "skuAmount",
          label: "Amount",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "skuValidity",
          label: "Validity",
          sortable: false,
        },
        {
          key: "addressType",
          label: "Input Type",
          sortable: false,
        },
        
      ],
      searchValue: {
        search: "",
        status: null,
        category: null,
        sort: 'id',
        orderDesc: true,
        service: null,
        serviceGroup: null,
        searchField: null,
      },
      statusList: [
        { text: "All", value: null },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      categoryList: [{ text: "All", value: null }],
      searching: false,
      eloadServiceOptions: [{ text: "All", value: null }],
      eloadPromoModule: {
        access: {
          create: false,
          update: false,
          delete: false
        }
      },
      eloadNetworkGroupOptions: [],
      selectAll: false,
      promos: [],
      includedPromos: [],
      excludedPromos: [],
    };
  },
  computed: {
    ...coreEloadDropdownComputed,
    ...coreEloadSKUMasterComputed,
    ...erpFixMessages,
  },
  mounted: async function() {
    this.getPromoList();
    this.getEloadCategoryList();
    this.getEloadServiceList();
    this.getNetworkGroups();
    this.changeTitle({title: 'E-Load SKU Master'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Load Core Manager', to: { name: 'E-Load Core SKU Master'} },
        { text: 'E-Load SKU Master', to: { name: 'E-Load Core SKU Master'} }
      ]
    });

    await getModuleAccess('Products', 'eLoad', 'eLoad Promo')
      .then((access) => this.eloadPromoModule.access = access);
  },
  methods: {
    ...layoutMethods,
    ...coreEloadDropdownMethods,
    ...coreEloadSKUMasterMethods,
    async onExport(){
      var self = this;
      await this.onPageUpdate("reset").then(function(){
        console.log("check this:",self.loadPromoTotalRows);
        if(self.loadPromoTotalRows == 0){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = {
            email: JSON.parse(localStorage.getItem('userData')).email,
            orderDesc: self.searchValue.orderDesc,
            search: self.searchValue.search,
            searchField: self.searchValue.searchField,
            sort: self.searchValue.sort,
            status: self.searchValue.status,
            category: self.searchValue.category,
            service: self.searchValue.service,
            serviceGroup: self.searchValue.serviceGroup,
          };
        
          self.actionCoreEloadSKUMasterAPIPOST({
            params: params,
            action: "export"
          })
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      })
    },
    async getPromoList() {
      await this.actionCoreEloadSKUMasterAPIPOST({
        params:{
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue
        },
        action: "list"}).then(async () => {
        this.promos = this.loadPromoList.map(item => ({ ...item, isChecked: false }));
        if (this.selectAll) await this.checkAll();
      })
    },
    async searchPromo() {
      await this.actionCoreEloadSKUMasterAPIPOST({
        params:{
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue
        },
        action: "list"}).then(async () => {
        this.promos = this.loadPromoList.map(item => ({ ...item, isChecked: false }));
        if (this.selectAll) await this.checkAll();
      })
    },
    async onPageUpdate(reset = "") {
      if(reset == "reset"){
        this.currentPage = 1
      }
      
      await this.searchPromo();

      this.selectAll = false;
      this.excludedPromos = [];
      this.includedPromos = [];
      await this.checkAll();
    },

    async getEloadServiceList() {
      this.fetchCoreServicesList().then(async () => {
        let sortedList = await this.sortOptions('service', [...this.getCoreServicesList]);
        for (let service of sortedList) {
          this.eloadServiceOptions.push({ text: service.service, value: service.service })
        }
      });
    },
    async getEloadCategoryList() {
      this.fetchCoreCategoriesList().then(async () => {
        let sortedList = await this.sortOptions('category', [...this.getCoreCategoriesList]);
        for(let data of sortedList){
          this.categoryList.push({ 'text': data.category, 'value': data.category })
        }
      })
    },
    async getNetworkGroups() {
      this.fetchCoreNetworksList().then(async () => {
        let sortedList = await this.sortOptions('name', JSON.parse(JSON.stringify(this.getCoreNetworksList)));
        for (let group of sortedList) {
          this.eloadNetworkGroupOptions.push({ text: group.name, value: group.name })
        }
      });
    },
    onDisplayChange(){
      if(
        (this.loadPromoList.length < this.loadPromoTotalRows && this.loadPromoList.length != this.perPage) ||
        (this.loadPromoList.length == this.loadPromoTotalRows && this.perPage < this.loadPromoList.length)
      ){
        this.onPageUpdate('reset')
      }
    },
    eloadPromoSort(ctx){
      const columnMap = {
        'skuId': 'id',
        'skuName': 'skuName',
        'skuCode': 'skuCode',
        'providerName': 'provider',
        'skuCategory': 'category',
        'skuServiceGroup': 'serviceGroup',
        'skuService': 'skuService',
        'skuAmount': 'amount',
        'skuValidity': 'validity',
        'skuStatus': 'status'
      };
      
      this.searchValue.sort = columnMap[ctx.sortBy] || ctx.sortBy;
      
      if (ctx.sortBy === 'skuStatus') {
        this.searchValue.orderDesc = !ctx.sortDesc;
      } else {
        this.searchValue.orderDesc = ctx.sortDesc;
      }
      
      this.currentPage = 1;
      this.onPageUpdate();
    },
    editPromo(item){
      this.$router.push({
        name: "E-Load Core SKU Master Form", params: { id: item.skuId }
      });
    },
    async sortOptions(propName, arr) {
      arr.sort((a, b) => {
        const nameA = a[`${propName}`].toUpperCase();
        const nameB = b[`${propName}`].toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return arr;
    },
    checkAll(){
      for (let promo of this.promos) {
        let excludedPromo = this.excludedPromos.find(item => item == promo);
        if (excludedPromo == null) {
          promo.isChecked = this.selectAll;
        }
      }
      this.includedPromos = [];
      this.excludedPromos = [];
    },
    onCheckboxTicked(promo) {
      if (this.selectAll) {
        if(!promo.isChecked) {
          this.excludedPromos.push(promo.promoId);
        } else {
          let index = this.excludedPromos.findIndex((item) => item == promo.promoId);
          if (index !== -1) this.excludedPromos.splice(index, 1);
        }
      } else {
        if (promo.isChecked) {
          this.includedPromos.push(promo.promoId)
        } else {
          let index = this.includedPromos.findIndex((item) => item == promo.promoId);
          if (index !== -1) this.includedPromos.splice(index, 1);
        }
      }
    },
    async changePromoStatus(status) {
      if (this.eloadPromoModule.access.update) {
        Swal.fire({
          title: 'Are you sure?',
          text: `Do you really want to ${status} the selected promo(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '##804997',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(async (result) => {
          if (result.isConfirmed) {
            // TODO: Implement bulk status update via SKU Master API
            this.$alertify.warning("Bulk status update not yet implemented");
          }
        })
      } else {
        Swal.fire(
          "Access Restricted",
          "You are not allowed to update Promo(s).",
          "warning"
        );
      }
    },
    async toggleSKUStatus(item, event) {
      // Immediately revert the checkbox to prevent visual change
      event.target.checked = item.skuStatus == '1';
      
      const currentStatus = item.skuStatus;
      const newStatus = currentStatus == '1' ? '0' : '1';
      const statusText = newStatus == '1' ? 'activate' : 'deactivate';
      
      Swal.fire({
        title: 'Are you sure?',
        text: `Do you really want to ${statusText} this SKU?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#6f42c1',
        cancelButtonColor: '#dc3545',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          popup: 'swal-popup',
          confirmButton: 'btn btn-primary px-4',
          cancelButton: 'btn btn-danger px-4'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.actionCoreEloadSKUMasterAPIPOST({
            params: {
              id: item.skuId,
              skuStatus: newStatus
            },
            action: "update"
          })
          .then((res) => {
            console.log(res);
            Swal.fire({
              title: 'Updated Successful!',
              text: `${item.skuName} is successfully ${statusText}d.`,
              icon: 'success',
              confirmButtonColor: '#6f42c1',
              confirmButtonText: 'OK',
              customClass: {
                popup: 'swal-popup',
                confirmButton: 'btn btn-primary'
              }
            });
            this.getPromoList();
          }).catch((e) => {
            Swal.fire({
              title: 'Update Failed!',
              text: `An error occurred while updating the sku status.`,
              icon: 'error',
              confirmButtonColor: '#dc3545',
              confirmButtonText: 'OK',
              customClass: {
                popup: 'swal-popup',
                confirmButton: 'btn btn-danger'
              }
            });
            console.log("error while updating sku status", e);
          });
          
        }
        // If user clicks "No", checkbox remains in original state (already reverted above)
      });
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2 mb-3">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{ loadPromoTotalRows }}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->

              <!-- Search and button -->
              <div class="col-md-8 col-sm-8 text-end mb-3"> 

                  <router-link :to="{ name: 'E-Load Core SKU Master Form', params: { id: 0 }}" class="tc-white me-2" v-if="eloadPromoModule.access.create">
                    <button class="btn btn-primary" >
                        <i class="uil uil-plus me-1"></i> Add SKU
                    </button>
                  </router-link>

                  <a class="btn btn-secondary" @click="onPageUpdate()"
                    ><feather
                      type="refresh-ccw"
                      size="16"
                      class="icon nav-icon"
                    ></feather
                    >&nbsp;&nbsp; Refresh</a
                  >
              </div>
              <!-- end col buttons-->

              <div class="col-md-12 col-sm-12">
                 <div class="row mt-4">
                    <div class="col-md-4 ta-right">
                      <b-form-group description="Search Keyword">
                        <form class="d-flex" @submit.prevent="onPageUpdate('reset')">
                          <b-form-group id="input-group-3" label-for="input-3">
                            <b-form-select
                              class="form-select rounded-0 rounded-start shadow-none"
                              style="width: fit-content"
                              id="input-3"
                              v-model="searchValue.searchField"
                              :options="searchListPromo"
                            ></b-form-select>
                          </b-form-group>

                          <b-input-group>
                            <b-form-input
                              class="rounded-0"
                              v-model="searchValue.search"
                            ></b-form-input>
                          </b-input-group>
                        </form>
                      </b-form-group>

                      <!-- <b-form-group description="Search Keyword">
                        
                        <b-input-group>
                          <b-form-input
                            v-model="searchValue.search"
                            placeholder="Search..."
                            @keyup.enter.native="onPageUpdate('reset')" 
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group> -->
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <div class="col-sm-3">
                          <b-form-group label-for="services" description="Filter by Service">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.service"
                              :options="eloadServiceOptions"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-3">
                          <b-form-group label-for="status" description="Filter by Status">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.status"
                              :options="statusList"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-3">
                          <b-form-group label-for="category" description="Filter by Category">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none" 
                              v-model="searchValue.category"
                              :options="categoryList"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right">
                        <div class="col-sm-3">
                          <b-form-group label-for="network" description="Filter by Network">
                            <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                              v-model="searchValue.serviceGroup"
                              :options="eloadNetworkGroupOptions"
                            >
                            <template #first>
                              <b-form-select-option :value="null"
                                >All</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                          </b-form-group>
                        </div>
                        <div class="col-sm-1" style="width: fit-content">
                            <b-button variant="primary" type="button" @click="onPageUpdate('reset')" class="px-2 d-flex align-items-center">
                              <div><i class='bx bx-search bx-fw'></i></div>
                              <div>Search</div>
                            </b-button>
                        </div>
                        <div class="col-sm-1" style="width: fit-content">
                            <b-button variant="primary" @click="onExport" type="button" class="px-2 d-flex align-items-center">
                              <div><i class='uil uil-export me-1'></i></div>
                              <div>Export</div>
                            </b-button>
                        </div>
                        <div class="col-sm-1" style="width: fit-content" v-if="selectAll || includedPromos.length">
                            <b-button variant="primary" @click="changePromoStatus('enable')" type="button" class="px-2 d-flex align-items-center">
                              <div><i class='bx bx-check me-1'></i></div>
                              <div>Enable</div>
                            </b-button>
                        </div>
                        <div class="col-sm-1" style="width: fit-content" v-if="selectAll || includedPromos.length">
                            <b-button variant="primary" @click="changePromoStatus('disable')" type="button" class="px-2 d-flex align-items-center">
                              <div><i class='bx bx-x me-1'></i></div>
                              <div>Disable</div>
                            </b-button>
                        </div>
                        <!-- <div class="col-sm-1" style="width: fit-content">
                            <b-button variant="primary" @click="editSchedule({scheduleId: 0})" type="button" class="px-2 d-flex align-items-center">
                              <div><i class='bx bx-calendar-alt me-1'></i></div>
                              <div>Set a Schedule</div>
                            </b-button>
                        </div> -->
                      </div>
                    </div>
                </div>

              </div> <!-- end of list of filter-->
            </div>
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="promos"
                  :fields="fields"
                  responsive="sm"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  class="table-check"
                  @sort-changed="eloadPromoSort"
                >
                  <!-- <template #head(all)>
                    <b-form-checkbox
                        v-model="selectAll"
                        @change="checkAll"
                        id="header-checkbox"
                        name="checkbox-1"
                        style="margin-bottom: 0px;"
                      > &nbsp; All </b-form-checkbox>
                  </template> -->

                  <!-- <template #cell(all)="row">
                    <div>
                      <b-form-checkbox
                          id="checkbox-1"
                          name="checkbox-1"
                          v-model="row.item.isChecked"
                          @change="onCheckboxTicked(row.item)"
                        ></b-form-checkbox>
                    </div>
                  </template> -->

                  <template #cell(skuId)="data">
                    <p class="text-body m-0">
                      {{ data.item.skuId }}
                    </p>
                  </template>

                  <template #cell(skuName)="data">
                    <b-link
                      class="fw-medium"
                      @click="editPromo(data.item)"
                      >{{ data.item.skuName }}</b-link
                    >
                  </template>

                  <template #cell(skuCode)="data">
                    <p class="text-body m-0">
                      {{ data.item.skuCode }}
                    </p>
                  </template>

                  <template #cell(providerName)="data">
                    <p class="text-body fw-medium m-0">
                      {{ data.item.providerName }}
                    </p>
                  </template>

                  <template #cell(skuCategory)="data">
                    <p class="text-body m-0" style="cursor: pointer;">
                      <span v-if="data.item.skuCategory && data.item.skuCategory.length > 18">
                        <span
                          class="d-inline-block"
                          tabindex="0"
                          style="border-bottom: 1px dotted #000;"
                          v-b-tooltip.hover="data.item.skuCategory"
                        >
                          {{ data.item.skuCategory.slice(0, 18) + '...' }}
                        </span>
                      </span>
                      <span v-else>
                        {{ data.item.skuCategory }}
                      </span>
                    </p>
                  </template>

                  <template #cell(skuServiceGroup)="data">
                    <p class="text-body fw-medium m-0">
                      {{ data.item.skuServiceGroup }}
                    </p>
                  </template>

                  <template #cell(skuDescription)="data">
                    <p class="text-body m-0">
                      {{
                        String(data.item.skuDescription).length > 22
                          ? String(data.item.skuDescription).substring(0, 22) + "..."
                          : data.item.skuDescription
                      }}
                    </p>
                  </template>

                  <template #cell(skuValidity)="data">
                    <p class="text-body m-0">{{ data.item.skuValidity }}</p>
                  </template>

                  <template #cell(addressType)="data">
                    <p class="text-body m-0">
                      {{ data.item.addressType == "AN" ? "Account Number" : "Mobile Number" }} - 
                      {{ data.item.addressMax }}
                    </p>
                  </template>

                  <template #cell(skuAmount)="data">
                    <p class="text-body m-0 text-end">
                      <span class="">PHP&nbsp;</span>{{ data.item.skuAmount }}
                    </p>
                  </template>

                  

                  <template #cell(skuStatus)="data">
                    <span :class="`${data.item.skuStatus == '1' ? 'text-success' : 'text-disabled'}`">
                        <div class="form-check form-switch form-switch-md mb-1 float-right mr-3" 
                            dir="ltr">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`statusSwitch_${data.item.skuId}`"
                                :checked="data.item.skuStatus == '0' ? false : true"
                                @change="toggleSKUStatus(data.item, $event)"
                            />
                            <label class="form-check-label form-label small" :for="`statusSwitch_${data.item.skuId}`">Active</label>
                        </div>
                    </span>
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row g-0 text-center" v-if="loadPromoTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start"  v-if="loadPromoTotalRows != 0 && loadPromoTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="loadPromoTotalRows > perPage"
                    >
                      <!-- pagination 
                        im ded owahfoiahwfwaiofhaoi

                        -sean
                         -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="onPageUpdate()"
                        :total-rows="loadPromoTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>

      <!-- <more-options v-model="modals.moreOptionsModal"/> -->
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>

<style>
.custom-checkbox label {
  margin: 0;
}
</style>